import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import FileAppResource from './FileAppResource';
import LuWorkspaceMembershipTypeAppResource from './LuWorkspaceMembershipTypeAppResource';
import OrganizationAppResource from './OrganizationAppResource';
import PhoneAppResource from './PhoneAppResource';
import PlaybookAppResource from './PlaybookAppResource';
import UserAppResource from './UserAppResource';

class UserProfileAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'user-profile';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'users/profiles';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'userUuid',
            'avatarFileUuid',
            'organizationUuid',
            'organizationLogoUuid',
            'workspaceMembershipTypeUuid',
            'homePurchasePlaybookUuid',
            'homeSalePlaybookUuid',
            'clientUrl',
            'branding',
            'firstName',
            'lastName',
            'displayName',
            'email',
            'organizationName',
            'phones',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            user: UserAppResource,
            avatarFile: FileAppResource,
            organization: OrganizationAppResource,
            organizationLogo: FileAppResource,
            workspaceMembershipType: LuWorkspaceMembershipTypeAppResource,
            homePurchasePlaybook: PlaybookAppResource,
            homeSalePlaybook: PlaybookAppResource,
            phones: PhoneAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            user: 'user_uuid',
            avatarFile: 'avatar_file_uuid',
            organization: 'organization_uuid',
            organizationLogo: 'organization_logo_uuid',
            workspaceMembershipType: 'workspace_membership_type_uuid',
            homePurchasePlaybook: 'home_purchase_playbook_uuid',
            homeSalePlaybook: 'home_sale_playbook_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            userUuid: {
                type: 'string',
                presence: true,
            },
            avatarFileUuid: {
                type: 'string',
            },
            organizationUuid: {
                type: 'string',
                presence: true,
            },
            organizationLogoUuid: {
                type: 'string',
            },
            workspaceMembershipTypeUuid: {
                type: 'string',
            },
            homePurchasePlaybookUuid: {
                type: 'string',
            },
            homeSalePlaybookUuid: {
                type: 'string',
            },
            clientUrl: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            firstName: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            lastName: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            displayName: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            email: {
                type: 'string',
                email: {
                    message: "Email is invalid"
                },
                length: {
                    maximum: 255,
                },
            },
            organizationName: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            phones: {
                type: 'array',
            },

            'branding.headline.value': {
                length: {
                    maximum: 255,
                },
            },
            'branding.introduction.value': {
                length: {
                    maximum: 500,
                },
            },
            'branding.callToAction.value': {
                length: {
                    maximum: 255,
                },
            },
            'branding.benefits.values': {
                arrayOfObjects: {
                    value: {
                        length: {
                            maximum: 255,
                        },
                    },
                    status: {
                        presence: true,
                    },
                },
            },
            'branding.social.website.value': {
                format: {
                    pattern: '^$|[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)',
                    message: 'Website is invalid.',
                },
                length: {
                    maximum: 255,
                },
            },
            'branding.social.facebook.value': {
                format: {
                    pattern: '^$|[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)',
                    message: 'Facebook profile is invalid.',
                },
                length: {
                    maximum: 255,
                },
            },
            'branding.social.linkedIn.value': {
                format: {
                    pattern: '^$|^https:\\/\\/[a-z]{2,3}\\.linkedin\\.com\\/.*$',
                    message: 'LinkedIn profile is invalid.',
                },
                length: {
                    maximum: 255,
                },
            },
            'branding.social.youTube.value': {
                format: {
                    pattern: '^$|[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)',
                    message: 'YouTube profile is invalid.',
                },
                length: {
                    maximum: 255,
                },
            },
            'branding.social.instagram.value': {
                format: {
                    pattern: '^$|^https:\\/\\/[a-z]{2,3}\\.instagram\\.com\\/.*$',
                    message: 'Instagram profile is invalid.',
                },
                length: {
                    maximum: 255,
                },
            },
        };
    }

}

export default UserProfileAppResource;
